import { register } from './components.js'

register()
